<template>
  <div id="app">
    <img alt="Пили шаблон!!!1" src="./assets/logo.png">
    <checkSampleGenerator/>
  </div>
</template>

<script>
import checkSampleGenerator from './components/checkSampleGenerator.vue'

export default {
  name: 'app',
  components: {
    checkSampleGenerator
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
